export default "__VITE_ASSET__ljQ5YSyz__"